import { useSyncExternalStore } from 'react';
import { now } from './helpers.js';

let state = {
  pending: [], quotes: [], audit: [], seq: 482, busy: false,
  view: 'chat', chat: [], pulse: {}, cmd: '', scrollTick: 0,
  sysUI: { open: null, path: [], erpTab: 0, tick: 0 }
};
const listeners = new Set();

export const getState = () => state;
export const setState = patch => {
  state = { ...state, ...(typeof patch === 'function' ? patch(state) : patch) };
  listeners.forEach(l => l());
};
export const useStore = () => useSyncExternalStore(
  l => { listeners.add(l); return () => listeners.delete(l); },
  getState
);

export const planEls = new Map();      // taslak no -> DOM öğesi ("Taslağı aç" için)
export const composer = { el: null };  // Composer textarea'sı

export const audit = text => setState(s => ({ audit: [{ t: now(), text }, ...s.audit] }));
export const show = id => setState({ view: id });
export const toBottom = () => setState(s => ({ scrollTick: s.scrollTick + 1 }));
export const setSys = (ids, on) => setState(s => {
  const pulse = { ...s.pulse };
  ids.forEach(id => { pulse[id] = on; });
  return { pulse };
});
export const setCmd = value => setState({ cmd: value });
export const focusCmd = () => { if (composer.el) composer.el.focus(); };
export const updateAgent = (id, fn) => setState(s => ({ chat: s.chat.map(c => (c.id === id ? fn(c) : c)) }));
export const updateSysUI = patch => setState(s => ({ sysUI: { ...s.sysUI, ...patch } }));
